import wxApi from '../wx'
import qs from 'qs'
import store from '@/store/index'
import config from '@/config/index'
export default {
  authWx (opts = {}) {
    // const AppId = config.appid //
    const localUrl = config.baseUrl
    const scope = opts.scope || 'snsapi_base'
    let pathName = String(window.location.hash)
    pathName = pathName.substring(1, pathName.length)
    const path = encodeURIComponent(pathName.split('?')[0] || '/')
    const query = qs.parse(pathName.split('?')[1] || '{}')
    let AppId = query.appid || config.appid;
    localStorage.setItem('appId',AppId)

    let params = {
      ...query,
      path: opts.path || path,
      ...opts.params
    }
    params = encodeURIComponent(qs.stringify(params))
    window.location.href =
      'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
      AppId +
      '&redirect_uri=' +
      encodeURIComponent(localUrl) +
      `&response_type=code&scope=${scope}&state=${params}&connect_redirect=1#wechat_redirect`

    // snsapi_base
    // snsapi_userinfo
  },
  async checkAuthPageNeedRedirect (hasToken) {
    let rs = '';
    const baseTwo = config.baseTwo;
    const hrefStr = String(window.location.href)
    if (/\/\?code\=/.test(hrefStr)) {
      let tempStr = hrefStr.match(/\?([^#]*)/g)
      tempStr = tempStr ? tempStr[0] || '' : ''
      tempStr = tempStr.replace(/\?/g, '')
      let data = null
      let query = {}
      let code = ''
      try {
        data = qs.parse(tempStr)
      } catch (e) {

      }
      if (data) {
        query = qs.parse(data.state)
        code = data.code;
        let appid = localStorage.getItem('appId')
        const res = await wxApi.getAppOpenId({ code , appid })
        console.log(res)
        // store.dispatch('user/login', res.data.token)
        if(res.data && res.data.length > 20){
          localStorage.setItem('token_key', res.data)
        }
        const tData = this.copyAttrIfExist({}, { ...query, path: '', code: '' })
        const path = decodeURIComponent(query.path) || '/'
        rs = { redirectURL: '/'+ baseTwo +'#' + path + '?' + qs.stringify(tData), params: tData }
      }
    }

    return rs
  },
  copyAttrIfExist (target, orgin) {
    const keys = Object.keys(orgin)
    const newObj = { ...target }
    keys.forEach(k => {
      if (orgin[k]) {
        newObj[k] = orgin[k]
      }
    })
    return newObj
  },
  getWxToken (code) {
    return wxApi.getAppOpenId(code)
  },
  verifySignature () {
    return new Promise((resolve, reject) => {
      const Url = window.location.href.split('#')[0]
      wxApi.getTicket(encodeURIComponent(Url), '').then(res => {
        const data = res.data
        const wxWrap = window.wx || null
        if (wxWrap) {
          wxWrap.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: process.env.VUE_APP_APPID, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.noncestr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名
            jsApiList: ['chooseImage', 'uploadImage', 'hideMenuItems'] // 必填，需要使用的JS接口列表
          })
          wxWrap.error(function (res) {
            console.log('errConfig :', res)
          })

          wxWrap.ready(function () {
            wxWrap.hideMenuItems({
              menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline'],
              success: res => {
                console.log('wx hide menu items success', res)
              }
            })
          })
        }
      })
    })
  }
}
